import React from 'react';
// Стили — в public/static/tree-loader.css: их же использует стартовый экран в index.html.

// Листья: точка крепления, угол (0 — вправо, -90 — вверх), размер, оттенок, волна появления.
const LEAVES = [
  [61, 93, -35, 0.55, 3, 1],
  [51, 77, -125, 0.8, 2, 1],
  [45, 68, -150, 1, 1, 1],
  [45, 68, 165, 0.85, 3, 1],
  [42, 64, -175, 0.7, 4, 1],
  [47, 58, -150, 0.75, 4, 2],
  [68, 67, -60, 0.8, 2, 2],
  [74, 58, -35, 1, 1, 2],
  [74, 58, 15, 0.85, 4, 2],
  [76, 52, -20, 0.75, 3, 2],
  [50, 47, -125, 0.95, 2, 2],
  [50, 47, -170, 0.8, 3, 3],
  [55, 52, -105, 0.8, 4, 3],
  [65, 50, -75, 0.8, 3, 3],
  [69, 44, -55, 0.95, 1, 3],
  [69, 44, -5, 0.8, 4, 3],
  [56, 40, -108, 0.85, 4, 3],
  [64, 40, -72, 0.85, 2, 3],
  [60, 43, -90, 1.05, 3, 3],
  [59, 45, -125, 0.85, 1, 3],
  [61, 45, -55, 0.85, 2, 3],
];
const LEAF = 'M0 0 C4 -5.5 11 -6 14 0 C11 6 4 5.5 0 0 Z';

const BRANCHES = [
  'M60 84 C54 80 49 76 45 68',
  'M60 74 C66 70 71 65 74 58',
  'M60 60 C55 56 52 52 50 47',
  'M60 57 C64 53 67 48 69 44',
];

// Мягкий объём кроны за листьями.
const CROWN = [
  [50, 58, 14],
  [70, 54, 14],
  [60, 42, 16],
];

// Светлячки над кроной: x, y, длительность полёта (с) — у каждого свой ритм.
const SPARKS = [
  [44, 50, 3.1],
  [76, 44, 3.9],
  [58, 30, 4.6],
];

const PHRASES = ['Сажаем семечко', 'Пускаем росток', 'Растим ветви', 'Распускаем листву'];

/**
 * Лоадер «растущее дерево»: из семечка поднимается ствол, расходятся ветви,
 * распускаются листья, один лист опадает — и всё начинается заново.
 *
 *   <TreeLoader label="Загрузка справочников…" />      — по центру области
 *   <TreeLoader fill label="Загрузка…" />              — на всю высоту экрана
 *   <TreeLoader compact label="Загрузка…" />           — маленький, в строку
 */
const TreeLoader = ({ label = 'Загрузка…', hint, compact = false, fill = false, className = '' }) => (
  <div
    className={['tree-loader', compact && 'tree-loader--compact', fill && 'tree-loader--fill', className]
      .filter(Boolean).join(' ')}
    role="status"
    aria-live="polite"
  >
    <svg className="tree-loader__svg" viewBox="0 0 120 120" aria-hidden="true">
      <defs>
        <radialGradient id="treeLoaderSun" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffe39a" />
          <stop offset="45%" stopColor="#ffe9a8" stopOpacity="0.7" />
          <stop offset="100%" stopColor="#ffe9a8" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="treeLoaderCrown" cx="45%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#dff1d3" />
          <stop offset="100%" stopColor="#c3e3b4" />
        </radialGradient>
        <linearGradient id="treeLoaderTrunk" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#5f412b" />
          <stop offset="100%" stopColor="#8d6a4b" />
        </linearGradient>
      </defs>

      <circle className="tree-loader__sun" cx="94" cy="24" r="18" fill="url(#treeLoaderSun)" />
      <ellipse className="tree-loader__shadow" cx="60" cy="105" rx="30" ry="3.5" />
      <path className="tree-loader__ground" d="M24 104 Q60 99 96 104" />
      <path className="tree-loader__grass" d="M33 103 l-1 -4 M36 103 l1 -5 M86 103 l1 -4 M83 103 l-1 -5" />

      <g className="tree-loader__plant">
        <ellipse className="tree-loader__seed" cx="60" cy="102.5" rx="3.2" ry="2.2" />
        <g className="tree-loader__sway">
          {CROWN.map(([cx, cy, r]) => (
            <circle key={`${cx}-${cy}`} className="tree-loader__crown" cx={cx} cy={cy} r={r} fill="url(#treeLoaderCrown)" />
          ))}
          <path className="tree-loader__trunk" d="M60 104 C61 92 58 82 60 66" pathLength="1" stroke="url(#treeLoaderTrunk)" />
          <path className="tree-loader__trunk tree-loader__trunk--top" d="M60 66.5 C61 58 60 50 60 43" pathLength="1" />
          {BRANCHES.map((d, i) => (
            <path key={d} className={`tree-loader__branch tree-loader__branch--${i + 1}`} d={d} pathLength="1" />
          ))}
          {LEAVES.map(([x, y, angle, size, tone, wave]) => (
            <g key={`${x}-${y}-${angle}`} transform={`translate(${x} ${y}) rotate(${angle}) scale(${size})`}>
              <path className={`tree-loader__leaf tree-loader__leaf--w${wave} tree-loader__leaf--t${tone}`} d={LEAF} />
            </g>
          ))}
        </g>
        <g transform="translate(74 58)">
          <path className="tree-loader__falling tree-loader__leaf--t2" d={LEAF} />
        </g>
        {SPARKS.map(([cx, cy, seconds]) => (
          <circle
            key={`${cx}-${cy}`}
            className="tree-loader__spark"
            cx={cx}
            cy={cy}
            r="1.1"
            style={{ animationDuration: `${seconds}s` }}
          />
        ))}
      </g>
    </svg>

    {compact ? (
      <span className="tree-loader__label">{label}</span>
    ) : (
      <div className="tree-loader__text">
        <div className="tree-loader__label">{label}</div>
        {hint ? (
          <div className="tree-loader__hint">{hint}</div>
        ) : (
          <div className="tree-loader__phrases" aria-hidden="true">
            {PHRASES.map((p, i) => (
              <span key={p} className={`tree-loader__phrase tree-loader__phrase--${i + 1}`}>{p}</span>
            ))}
          </div>
        )}
      </div>
    )}
  </div>
);

export default TreeLoader;
